"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAccessEditSchema = exports.APP_PAGE_ACCESS_RULE_REMEDIES = exports.AppPageAccessRuleIdSchema = exports.APP_BASE_COMMAND_HOST_ONLY = exports.APP_BASE_PAGE_ACCESS_DENIED = exports.APP_REFRESH_LIVE_AVAILABLE = exports.AppPageKindSchema = exports.APP_ACCESS_AUDIENCE_PRINCIPAL_TYPES = exports.APP_ACCESS_STANDARD = exports.APP_ACCESS_TEMPLATES = exports.AppPageAccessSectionSchema = exports.AppRefreshAudienceSchema = exports.AppPageRefreshSchema = void 0;
exports.appAccessTemplateOf = appAccessTemplateOf;
exports.pagePrincipal = pagePrincipal;
exports.appAccessAudienceOf = appAccessAudienceOf;
exports.appViewerPrincipal = appViewerPrincipal;
exports.appContainerAccess = appContainerAccess;
exports.appAccessSetting = appAccessSetting;
exports.appPageAudienceAccess = appPageAudienceAccess;
exports.appPageKind = appPageKind;
exports.appPageKindEdits = appPageKindEdits;
exports.appRefreshSetting = appRefreshSetting;
exports.appPageRefreshSetting = appPageRefreshSetting;
exports.appPageKindRefreshAudience = appPageKindRefreshAudience;
exports.appPageRefreshLive = appPageRefreshLive;
exports.appPageLiveData = appPageLiveData;
exports.appPageAudienceReachesAnyPage = appPageAudienceReachesAnyPage;
exports.appBaseReachedAudiences = appBaseReachedAudiences;
exports.appBaseOpensOnlyToMembers = appBaseOpensOnlyToMembers;
exports.appPortalReachesAnyPage = appPortalReachesAnyPage;
exports.resolveAppPageAccess = resolveAppPageAccess;
exports.appTableAudiences = appTableAudiences;
exports.appTableWriteAudiences = appTableWriteAudiences;
exports.appTableReadsAllColumns = appTableReadsAllColumns;
exports.appWriteExposureIssues = appWriteExposureIssues;
exports.appPageTableRowScope = appPageTableRowScope;
exports.appPageEntryAdmission = appPageEntryAdmission;
exports.appPageEnteredBy = appPageEnteredBy;
exports.appPageOfferedTo = appPageOfferedTo;
exports.appPageDeliveredFor = appPageDeliveredFor;
exports.appNavigationOpenTo = appNavigationOpenTo;
exports.appTopBarOpenTo = appTopBarOpenTo;
exports.appPageCapabilityAllowed = appPageCapabilityAllowed;
exports.describeAppPageAccessIssue = describeAppPageAccessIssue;
exports.validateAppPageAccess = validateAppPageAccess;
exports.appAccessRecommendationEdits = appAccessRecommendationEdits;
exports.applyAppAccessEdit = applyAppAccessEdit;
exports.appPagesKeepingRights = appPagesKeepingRights;
exports.appPageAccessForRoutes = appPageAccessForRoutes;
exports.appAccessEditIssues = appAccessEditIssues;
exports.appPageTables = appPageTables;
exports.appDefinitionAccessIssues = appDefinitionAccessIssues;
exports.formatAppPageAccessIssue = formatAppPageAccessIssue;
exports.appBaseServesPortal = appBaseServesPortal;
const zod_1 = require("zod");
const app_access_vocabulary_1 = require("./app-access-vocabulary");
const app_base_contract_1 = require("./app-base-contract");
/**
 * Page rights of an App (epc-arm-1-vertrag, card dec-arm-access-like-doc-rights).
 *
 * Per page and audience (members of the workspace, portal persons, visitors)
 * an audience is active or not there at all. An active audience reads its own
 * rows, the rows of its groups or all rows; on top it may create rows and
 * change or delete rows, each off, only own rows, or like reading. An extra
 * right never reaches more rows than reading. A table of the page may narrow
 * or widen this and mark single columns read-only.
 *
 * Inheritance follows documents: container defaults (else the App standard,
 * APP_ACCESS_STANDARD), then the page, then the table. The workspace role of
 * a member stays the upper bound, and a group grant adds rights to the
 * persons of that group.
 */
/**
 * How the pages portal persons or visitors open stay current (card
 * dec-app-delivery-modes-limits-1028): economical serves a portal page
 * without a live connection and a public page through the CDN; live keeps
 * every person of the page connected (after go-live, APP_REFRESH_LIVE_AVAILABLE).
 * Members always run live.
 */
exports.AppPageRefreshSchema = zod_1.z.enum(['economical', 'live']);
/** The audiences whose pages choose how they stay current. */
exports.AppRefreshAudienceSchema = zod_1.z.enum(['portal', 'public']);
const AppRefreshSettingsSchema = zod_1.z
    .object({
    portal: exports.AppPageRefreshSchema.optional(),
    public: exports.AppPageRefreshSchema.optional(),
})
    .strict();
/** The access section of an App container. */
exports.AppPageAccessSectionSchema = zod_1.z
    .object({
    defaults: (0, app_access_vocabulary_1.appAccessAudienceRecord)(app_access_vocabulary_1.AppAudienceAccessSchema).prefault({}),
    pages: zod_1.z.record(zod_1.z.string().min(1), app_access_vocabulary_1.AppPageAccessSchema).prefault({}),
    /** Once for the App, a page only where it differs. */
    refresh: zod_1.z
        .object({
        app: AppRefreshSettingsSchema.prefault({}),
        pages: zod_1.z
            .record(zod_1.z.string().min(1), AppRefreshSettingsSchema)
            .prefault({}),
    })
        .strict()
        .prefault({}),
})
    .strict();
exports.APP_ACCESS_TEMPLATES = {
    viewOnly: { read: 'all', create: false, update: 'off', delete: 'off' },
    submit: { read: 'own', create: true, update: 'off', delete: 'off' },
    manageOwn: {
        read: 'own',
        create: true,
        update: 'likeRead',
        delete: 'likeRead',
    },
    editAll: {
        read: 'all',
        create: true,
        update: 'likeRead',
        delete: 'likeRead',
    },
};
/**
 * What an App gives an audience nothing sets anything for: members edit
 * everything (their workspace role stays the upper bound), portal persons and
 * visitors are off. Only what someone switches on on purpose opens beyond the
 * workspace.
 */
exports.APP_ACCESS_STANDARD = {
    internal: { active: true, ...exports.APP_ACCESS_TEMPLATES.editAll },
    portal: { active: false },
    public: { active: false },
};
/**
 * The standard of an audience on a page that portal persons or visitors may
 * open or not: members belong to internal pages only (card
 * dec-app-delivery-modes-limits-1028), so a page open beyond the workspace
 * keeps members off and stays as cheap as its kind allows.
 */
function standardAccess(audience, opensBeyondWorkspace) {
    return audience === 'internal' && opensBeyondWorkspace
        ? { active: false }
        : exports.APP_ACCESS_STANDARD[audience];
}
/** Whether portal persons or visitors are active in these settings. */
function opensBeyondWorkspace(portal, visitors) {
    return portal?.active === true || visitors?.active === true;
}
/** The template the rights match exactly, or null for own settings. */
function appAccessTemplateOf(rights) {
    return (app_access_vocabulary_1.AppAccessTemplateSchema.options.find(template => {
        const preset = exports.APP_ACCESS_TEMPLATES[template];
        return (preset.read === rights.read &&
            preset.create === rights.create &&
            preset.update === rights.update &&
            preset.delete === rights.delete);
    }) ?? null);
}
/**
 * The person as the page rights know them: the verified type of the person,
 * their groups and the role of what they do. A member who writes counts as a
 * writing member: their Doc role on the table bounds the write, which the
 * action admission checks. Server and StreamKit take the person from here.
 */
function pagePrincipal(type, groupIds, role) {
    if (type === 'anonymous')
        return { kind: 'visitor' };
    if (type === 'portal')
        return { kind: 'portal', groupIds };
    return { kind: 'member', groupIds, role };
}
/** The principal type a person acts as on a page they use as an audience. */
exports.APP_ACCESS_AUDIENCE_PRINCIPAL_TYPES = {
    internal: 'workspaceMember',
    portal: 'portal',
    public: 'anonymous',
};
/** The audience a person of a principal type uses a page as. */
function appAccessAudienceOf(principalType) {
    switch (principalType) {
        case 'workspaceMember':
            return 'internal';
        case 'portal':
            return 'portal';
        case 'anonymous':
            return 'public';
    }
}
/** The principal a delivered snapshot is for; groups never widen reading. */
function appViewerPrincipal(viewer) {
    switch (viewer) {
        case 'public':
            return { kind: 'visitor' };
        case 'portal':
            return { kind: 'portal', groupIds: [] };
        case 'member':
            return { kind: 'member', groupIds: [], role: 'read' };
    }
}
/**
 * The audiences a person can use a page as, nearest first: a member uses a
 * portal page like a portal person, and everybody uses a public page like a
 * visitor. A member without a role on the container is only a visitor.
 */
function audiencesOf(principal) {
    if (principal.kind === 'visitor')
        return ['public'];
    if (principal.kind === 'portal')
        return ['portal', 'public'];
    return principal.role === 'none'
        ? ['public']
        : ['internal', 'portal', 'public'];
}
const SCOPE_RANK = { own: 0, group: 1, all: 2 };
const NO_TABLE_ACCESS = {
    readFilter: null,
    create: false,
    updateFilter: null,
    deleteFilter: null,
    readOnlyColumns: [],
};
function wider(left, right) {
    if (!left)
        return right;
    if (!right)
        return left;
    return SCOPE_RANK[left] >= SCOPE_RANK[right] ? left : right;
}
function changeScope(change, read) {
    if (change === 'off')
        return null;
    return change === 'own' ? 'own' : read;
}
/** A scope the audience can reach: a visitor has no rows of its own. */
function reachable(scope, audience) {
    return audience === 'public' && scope !== 'all' ? null : scope;
}
function findPage(section, routePath) {
    if (!section)
        return undefined;
    const path = (0, app_base_contract_1.normalizeAppRoutePath)(routePath);
    return Object.entries(section.pages).find(([key]) => (0, app_base_contract_1.normalizeAppRoutePath)(key) === path)?.[1];
}
/** What the container gives an audience: its own default, else the standard. */
function appContainerAccess(section, audience) {
    return (section?.defaults[audience] ??
        standardAccess(audience, opensBeyondWorkspace(section?.defaults.portal, section?.defaults.public)));
}
function settingOn(section, page, audience, sourceKey) {
    const table = sourceKey === undefined ? undefined : page?.tables[sourceKey]?.[audience];
    return table
        ? { from: 'table', access: table }
        : pageSetting(section, page, audience);
}
/** The setting of an audience on a page itself: its own, else the container. */
function pageSetting(section, page, audience) {
    const own = page?.audiences[audience];
    if (own)
        return { from: 'page', access: own };
    return {
        from: 'container',
        access: section?.defaults[audience] ??
            standardAccess(audience, opensBeyondWorkspace(page?.audiences.portal ?? section?.defaults.portal, page?.audiences.public ?? section?.defaults.public)),
    };
}
function pageAudience(section, page, audience) {
    return pageSetting(section, page, audience).access;
}
/** The setting of an audience on a page, or on one table of it. */
function appAccessSetting(section, routePath, audience, sourceKey) {
    return settingOn(section, findPage(section, routePath), audience, sourceKey);
}
/** The access a page gives one audience: its own setting, else the default. */
function appPageAudienceAccess(section, routePath, audience) {
    return pageAudience(section, findPage(section, routePath), audience);
}
/**
 * What a page is for, the one choice the Studio shows first (card
 * dec-app-delivery-modes-limits-1028): internal for members, portal for
 * signed-in portal persons, public for visitors reading, publicForm for
 * visitors reading and submitting. The kind follows from the page rights;
 * nothing stores it apart.
 */
exports.AppPageKindSchema = zod_1.z.enum([
    'internal',
    'portal',
    'public',
    'publicForm',
]);
/** The kind of a page, read from its rights. */
function appPageKind(section, routePath) {
    const visitors = appPageAudienceAccess(section, routePath, 'public');
    if (visitors.active)
        return visitors.create ? 'publicForm' : 'public';
    return appPageAudienceAccess(section, routePath, 'portal').active
        ? 'portal'
        : 'internal';
}
/** What visitors get on a page of each open kind. */
const VISITOR_KIND_ACCESS = {
    public: { active: true, ...exports.APP_ACCESS_TEMPLATES.viewOnly },
    publicForm: {
        active: true,
        read: 'all',
        create: true,
        update: 'off',
        delete: 'off',
    },
};
/**
 * The edits that make a page one kind. An audience keeps no own setting where
 * the App gives it what the kind needs, so the page sets only what differs;
 * a portal page keeps the portal rights it has.
 */
function appPageKindEdits(section, routePath, kind) {
    const off = { active: false };
    const portal = appPageAudienceAccess(section, routePath, 'portal');
    const targets = {
        portal: kind !== 'portal'
            ? off
            : portal.active
                ? portal
                : { active: true, ...exports.APP_ACCESS_TEMPLATES.viewOnly },
        public: kind === 'public' || kind === 'publicForm'
            ? VISITOR_KIND_ACCESS[kind]
            : off,
        // Members follow the App on internal pages, get the standard where the
        // App keeps them off (an internal page someone opens), and are off on the
        // others.
        internal: kind === 'internal' ? 'inherit' : off,
    };
    const edits = [];
    let next = section;
    // Members last: their standard follows the other audiences of the page.
    for (const audience of ['portal', 'public', 'internal']) {
        const target = targets[audience];
        const inherit = { kind: 'inherit', routePath, audience };
        const inheritedAccess = appPageAudienceAccess(applyAppAccessEdit(next, inherit), routePath, audience);
        const wanted = target === 'inherit' && !inheritedAccess.active
            ? exports.APP_ACCESS_STANDARD[audience]
            : target;
        const edit = wanted === 'inherit' || sameAudienceAccess(inheritedAccess, wanted)
            ? inherit
            : { kind: 'set', routePath, audience, access: wanted };
        next = applyAppAccessEdit(next, edit);
        edits.push(edit);
    }
    // The own refresh of an audience the kind no longer shows goes with it, so
    // a later change back does not bring back live pages unasked.
    const shown = appPageKindRefreshAudience(kind);
    for (const audience of exports.AppRefreshAudienceSchema.options)
        if (audience !== shown &&
            appPageRefreshSetting(section, routePath, audience).from === 'page')
            edits.push({ kind: 'refresh', routePath, audience, refresh: null });
    return edits;
}
function findRefreshPage(section, routePath) {
    const path = (0, app_base_contract_1.normalizeAppRoutePath)(routePath);
    const pages = section?.refresh.pages ?? {};
    const key = Object.keys(pages).find(candidate => (0, app_base_contract_1.normalizeAppRoutePath)(candidate) === path);
    return key === undefined ? undefined : pages[key];
}
/** How the App keeps its pages for one audience current. */
function appRefreshSetting(section, audience) {
    const own = section?.refresh.app[audience];
    return own
        ? { from: 'app', refresh: own }
        : { from: 'standard', refresh: 'economical' };
}
/** How a page stays current for one audience: its own, else the App's. */
function appPageRefreshSetting(section, routePath, audience) {
    const own = findRefreshPage(section, routePath)?.[audience];
    return own
        ? { from: 'page', refresh: own }
        : appRefreshSetting(section, audience);
}
/**
 * Whether live refresh runs for an audience yet. Portal and public pages load
 * on open and on switching until live for them comes after go-live; their
 * stored setting stays as the author chose it.
 */
exports.APP_REFRESH_LIVE_AVAILABLE = { portal: false, public: false };
/** Whose refresh setting a page of a kind follows; an internal page none. */
function appPageKindRefreshAudience(kind) {
    if (kind === 'portal')
        return 'portal';
    return kind === 'internal' ? null : 'public';
}
/**
 * Whether a page runs live for portal persons or visitors: their setting
 * chose live and live is available for them yet.
 */
function appPageRefreshLive(section, routePath, audience) {
    return (exports.APP_REFRESH_LIVE_AVAILABLE[audience] &&
        appPageRefreshSetting(section, routePath, audience).refresh === 'live');
}
/**
 * Whether a page keeps the persons on it connected: members always, portal
 * persons and visitors only where the page runs live. The kind of the page
 * decides whose setting counts, as the Studio shows it.
 */
function appPageLiveData(section, routePath) {
    const audience = appPageKindRefreshAudience(appPageKind(section, routePath));
    return audience
        ? appPageRefreshLive(section, routePath, audience)
        : appPageAudienceAccess(section, routePath, 'internal').active;
}
function sameAudienceAccess(left, right) {
    if (!left.active || !right.active)
        return left.active === right.active;
    return (left.read === right.read &&
        left.create === right.create &&
        left.update === right.update &&
        left.delete === right.delete);
}
function isActive(access) {
    return access?.active === true;
}
/** Whether the page rights let this audience open any of these pages. */
function appPageAudienceReachesAnyPage(section, routePaths, audience) {
    return routePaths.some(path => isActive(appPageAudienceAccess(section, path, audience)));
}
/**
 * The audiences that open at least one page of an App Container, in the
 * order of AppAccessAudienceSchema. Whatever holds for the container as a
 * whole (portal offered, open to visitors) follows from here: the container
 * has no kind and no access of its own.
 */
function appBaseReachedAudiences(appBaseConfig) {
    const routePaths = (appBaseConfig.appBase?.routes ?? []).map(route => route.path);
    return app_access_vocabulary_1.AppAccessAudienceSchema.options.filter(audience => appPageAudienceReachesAnyPage(appBaseConfig.pageAccess, routePaths, audience));
}
/**
 * Whether only workspace members open the pages of an App Container (or
 * nobody does): then the whole container takes members only.
 */
function appBaseOpensOnlyToMembers(appBaseConfig) {
    const reached = appBaseReachedAudiences(appBaseConfig);
    return !reached.includes('public') && !reached.includes('portal');
}
/**
 * Whether the page rights let portal people open any of these pages: then the
 * App Container serves its portal (sign-in, session, portal state). Studio
 * and server read it from here.
 */
function appPortalReachesAnyPage(section, routePaths) {
    return appPageAudienceReachesAnyPage(section, routePaths, 'portal');
}
/**
 * The one access decision of a page: whether the person enters it and what
 * they may do in each of its tables.
 */
function resolveAppPageAccess(input) {
    const { section, principal } = input;
    const page = findPage(section, input.routePath);
    const audience = audiencesOf(principal).find(candidate => isActive(pageAudience(section, page, candidate)));
    if (!audience) {
        const signedInThere = principal.kind === 'visitor' &&
            (isActive(pageAudience(section, page, 'portal')) ||
                isActive(pageAudience(section, page, 'internal')));
        return {
            entry: signedInThere ? 'signIn' : 'denied',
            actsAs: null,
            tables: {},
        };
    }
    // Acting as a visitor, a person is one: groups and the right to write of
    // a membership play no part.
    const groupIds = audience === 'public' || principal.kind === 'visitor'
        ? []
        : principal.groupIds;
    const mayWrite = audience === 'public' ||
        principal.kind !== 'member' ||
        principal.role === 'write';
    const tables = {};
    for (const sourceKey of input.sourceKeys) {
        const setting = settingOn(section, page, audience, sourceKey);
        const access = setting.access;
        if (!access?.active) {
            tables[sourceKey] = NO_TABLE_ACCESS;
            continue;
        }
        let create = access.create;
        let updateFilter = changeScope(access.update, access.read);
        let deleteFilter = changeScope(access.delete, access.read);
        for (const grant of page?.groups ?? []) {
            if (grant.audience !== audience ||
                !groupIds.includes(grant.groupId) ||
                (grant.sourceKey !== undefined && grant.sourceKey !== sourceKey))
                continue;
            create ||= grant.create;
            updateFilter = wider(updateFilter, changeScope(grant.update, access.read));
            deleteFilter = wider(deleteFilter, changeScope(grant.delete, access.read));
        }
        tables[sourceKey] = {
            readFilter: reachable(access.read, audience),
            create: mayWrite && create,
            updateFilter: mayWrite ? reachable(updateFilter, audience) : null,
            deleteFilter: mayWrite ? reachable(deleteFilter, audience) : null,
            readOnlyColumns: setting.from === 'table' && setting.access.active
                ? setting.access.readOnlyColumns
                : [],
        };
    }
    return { entry: 'open', actsAs: audience, tables };
}
/**
 * The audiences a table is released for: each audience one page with the
 * table lets read it as that audience. `routes` name the tables of each page
 * (appPageTables for an App, appPageAccessRoutes for a container); the order
 * is the one of AppAccessAudienceSchema.
 */
function appTableAudiences(section, routes, sourceKey) {
    const viewers = {
        internal: 'member',
        portal: 'portal',
        public: 'public',
    };
    return app_access_vocabulary_1.AppAccessAudienceSchema.options.filter(audience => routes.some(route => {
        if (!route.dataSourceKeys.includes(sourceKey))
            return false;
        const decision = resolveAppPageAccess({
            section,
            routePath: route.path,
            sourceKeys: [sourceKey],
            principal: appViewerPrincipal(viewers[audience]),
        });
        return (decision.actsAs === audience &&
            (decision.tables[sourceKey]?.readFilter ?? null) !== null);
    }));
}
/**
 * The audiences one of these pages lets create, change or remove rows of the
 * table, in the order of AppAccessAudienceSchema. A member writes with their
 * right to write. `routes[].dataSourceKeys` are the tables of each page
 * (appPageTables), as for appTableAudiences.
 */
function appTableWriteAudiences(section, routes, sourceKey) {
    return app_access_vocabulary_1.AppAccessAudienceSchema.options.filter(audience => routes.some(route => {
        if (!route.dataSourceKeys.includes(sourceKey))
            return false;
        const decision = resolveAppPageAccess({
            section,
            routePath: route.path,
            sourceKeys: [sourceKey],
            principal: pagePrincipal(exports.APP_ACCESS_AUDIENCE_PRINCIPAL_TYPES[audience], [], 'write'),
        });
        const table = decision.tables[sourceKey];
        return (decision.actsAs === audience &&
            ['create', 'update', 'delete'].some(operation => appPageTableRowScope(table, operation) !== null));
    }));
}
/**
 * Whether members alone read the table on these pages and nobody writes it
 * there: then every column may be read and no column list is needed. A table
 * no page reads keeps its column list.
 */
function appTableReadsAllColumns(section, routes, sourceKey) {
    const readers = appTableAudiences(section, routes, sourceKey);
    return (readers.length === 1 &&
        readers[0] === 'internal' &&
        appTableWriteAudiences(section, routes, sourceKey).length === 0);
}
/**
 * The commands that add rows to a table no page lets anybody write: nobody
 * could ever run them. The platform and the StreamKit refuse them alike.
 */
function appWriteExposureIssues(input) {
    return input.actions.flatMap(action => action.type === 'rowInsert' &&
        action.sourceKey !== undefined &&
        appTableWriteAudiences(input.section, input.routes, action.sourceKey)
            .length === 0
        ? [`${action.sourceKey} action ${action.id} requires write exposure`]
        : []);
}
/** The answer when the page gives the person no right to what they do. */
exports.APP_BASE_PAGE_ACCESS_DENIED = 'APP_BASE_PAGE_ACCESS_DENIED';
/** The answer when a page sends a command only the host of its App runs. */
exports.APP_BASE_COMMAND_HOST_ONLY = 'APP_BASE_COMMAND_HOST_ONLY';
/**
 * The rows an operation reaches in a table of a page; null reaches none. A
 * person who writes without reading reads their own rows: a form shows what
 * it sent. Creating reaches the rows the person then reads.
 */
function appPageTableRowScope(table, operation) {
    if (!table)
        return null;
    switch (operation) {
        case 'read':
            return (table.readFilter ??
                (table.create ||
                    table.updateFilter !== null ||
                    table.deleteFilter !== null
                    ? 'own'
                    : null));
        case 'create':
            return table.create ? (table.readFilter ?? 'own') : null;
        case 'update':
            return table.updateFilter;
        case 'delete':
            return table.deleteFilter;
    }
}
/**
 * Which admission opening the page needs: a page open to visitors takes every
 * viewer of the App, a page for portal persons a portal person or a member, a
 * page only for members a member. Null when no audience opens the page.
 */
function appPageEntryAdmission(section, routePath) {
    const opens = (principal) => resolveAppPageAccess({ section, routePath, sourceKeys: [], principal })
        .entry === 'open';
    if (opens({ kind: 'visitor' }))
        return 'viewer';
    if (opens({ kind: 'portal', groupIds: [] }))
        return 'portalOrMember';
    if (opens({ kind: 'member', groupIds: [], role: 'read' }))
        return 'member';
    return null;
}
/**
 * Whether the principal of an App release enters the page at `routePath`:
 * a visitor only pages open to visitors, a portal member also pages behind
 * the sign-in, a workspace member every page an audience opens.
 */
function appPageEnteredBy(section, routePath, principal) {
    switch (appPageEntryAdmission(section, routePath)) {
        case 'viewer':
            return true;
        case 'portalOrMember':
            return principal !== 'public';
        case 'member':
            return principal === 'workspace-member';
        case null:
            return false;
    }
}
/**
 * Whether the menu offers `viewer` the page at `routePath`, by the rule of the
 * navigation actions: a page behind sign-in is offered (its delivery asks for
 * the sign-in), a page only members enter only to a member, a page no
 * audience opens never.
 */
function appPageOfferedTo(section, routePath, viewer) {
    switch (appPageEntryAdmission(section, routePath)) {
        case 'viewer':
        case 'portalOrMember':
            return true;
        case 'member':
            return viewer === 'member';
        case null:
            return false;
    }
}
/**
 * Whom the platform delivers the page at `routePath` for: a page open to
 * visitors is the same for everyone (one cached document), any other page is
 * delivered for the viewer who entered it. A container only members open is
 * read by members only, so its viewer is a member anyway.
 */
function appPageDeliveredFor(section, routePath, viewer) {
    return appPageEntryAdmission(section, routePath) === 'viewer'
        ? 'public'
        : viewer;
}
/**
 * The entries of the merged navigation offered to `viewer`
 * (appPageOfferedTo), so a visitor never sees the pages of the staff.
 * Actions stay; an entry whose parent is left out stands alone.
 */
function appNavigationOpenTo(navigation, section, viewer) {
    const open = navigation.filter(item => item.path === undefined ||
        appPageOfferedTo(section, (0, app_base_contract_1.normalizeAppRoutePath)(item.path), viewer));
    const ids = new Set(open.map(item => item.id));
    return open.map(item => {
        if (item.parentId === undefined || ids.has(item.parentId))
            return item;
        const { parentId: _orphaned, ...rest } = item;
        return rest;
    });
}
/**
 * The top bar entries offered to `viewer`: a link like a navigation entry
 * (appNavigationOpenTo), a panel only while the viewer may enter a page of
 * the App that brings it, so a visitor never gets the panel of a staff App.
 * In an App Container an entry belongs to the mount of its id prefix
 * (`<mountId>:`); a single App owns all its entries and the page itself.
 */
function appTopBarOpenTo(topBar, appDeliveries, currentRoutePath, section, viewer) {
    const offered = (path) => appPageOfferedTo(section, (0, app_base_contract_1.normalizeAppRoutePath)(path), viewer);
    return topBar.filter(item => {
        if (item.path !== undefined)
            return offered(item.path);
        if (!appDeliveries?.length)
            return offered(currentRoutePath);
        const owner = appDeliveries.find(delivery => (0, app_base_contract_1.scopedAppIdOfMount)(item.id, delivery.mountId));
        return owner?.routePaths.some(offered) ?? false;
    });
}
/**
 * Whether a platform capability on one table of the page is allowed. Live
 * calls, Agent Actions, automations and the member list belong to members of
 * the workspace who read the table.
 */
function appPageCapabilityAllowed(decision, sourceKey, capability) {
    const table = decision.tables[sourceKey];
    if (decision.entry !== 'open' || !table)
        return false;
    switch (capability) {
        case 'dataset.readWindow':
        case 'document.export':
            return table.readFilter !== null;
        case 'database.row.insert':
            return table.create;
        case 'database.row.update':
        case 'attachment.update':
            return table.updateFilter !== null;
        case 'database.row.delete':
            return table.deleteFilter !== null;
        case 'dataset.subscribe':
        case 'agentAction.invoke':
        case 'automation.run':
        case 'members.read':
        case 'dataset.restore':
            return decision.actsAs === 'internal' && table.readFilter !== null;
    }
}
exports.AppPageAccessRuleIdSchema = zod_1.z.enum([
    'access.unknown-page',
    'access.unknown-table',
    'access.unknown-column',
    'access.visitor-group-read',
    'access.visitor-change-needs-identity',
    'access.group-grant-inactive-audience',
    'access.members-on-open-page',
]);
/** What an editor does when a rights edit breaks a rule; agents read it. */
exports.APP_PAGE_ACCESS_RULE_REMEDIES = {
    'access.unknown-page': 'Name a page of the App (routePath of one of its routes).',
    'access.unknown-table': 'Name a table the page reads (one of its dataSourceKeys).',
    'access.unknown-column': 'Name a column of the table.',
    'access.visitor-group-read': 'Visitors belong to no group: give them read "own" or "all", or turn them off.',
    'access.visitor-change-needs-identity': 'Visitors are not signed in: let them change or delete only "likeRead", or turn the right off.',
    'access.group-grant-inactive-audience': 'Remove the group rights of this audience before turning it off.',
    'access.members-on-open-page': 'Members use internal pages only: keep members off this portal or visitor page and give them an internal page of their own.',
};
/** One broken rule with its place and remedy, for error messages. */
function describeAppPageAccessIssue(issue) {
    const where = [
        issue.routePath && `page ${issue.routePath}`,
        issue.sourceKey && `table ${issue.sourceKey}`,
        issue.columnId && `column ${issue.columnId}`,
        issue.audience && `audience ${issue.audience}`,
        issue.groupId && `group ${issue.groupId}`,
    ].filter(Boolean);
    return `${issue.ruleId}${where.length ? ` (${where.join(', ')})` : ''}: ${exports.APP_PAGE_ACCESS_RULE_REMEDIES[issue.ruleId]}`;
}
/**
 * The rules an access section must keep against the pages and tables of its
 * App. Combinations the model cannot express need no rule: an extra right is
 * bounded by reading by construction.
 */
function validateAppPageAccess(section, context) {
    const issues = [];
    const checkVisitor = (access, where) => {
        if (!access?.active)
            return;
        const base = { ...where, audience: 'public' };
        if (access.read === 'group')
            issues.push({ ruleId: 'access.visitor-group-read', ...base });
        const changes = [access.update, access.delete].map(change => changeScope(change, access.read));
        if (changes.some(scope => scope !== null && scope !== 'all'))
            issues.push({ ruleId: 'access.visitor-change-needs-identity', ...base });
    };
    checkVisitor(section.defaults.public, {});
    // Members belong to internal pages only; a page portal persons or visitors
    // open keeps them off, on the page and on each of its tables. What a page
    // only inherits from the container is reported once, at the container.
    const containerKeepsMembersOpen = opensBeyondWorkspace(appContainerAccess(section, 'portal'), appContainerAccess(section, 'public')) && appContainerAccess(section, 'internal').active;
    const checkMembers = (routePath, page) => {
        const portal = pageAudience(section, page, 'portal');
        const visitors = pageAudience(section, page, 'public');
        if (!opensBeyondWorkspace(portal, visitors))
            return;
        const where = routePath === undefined ? {} : { routePath };
        const inherited = page !== undefined &&
            page.audiences.internal === undefined &&
            containerKeepsMembersOpen;
        if (!inherited && pageAudience(section, page, 'internal').active)
            issues.push({
                ruleId: 'access.members-on-open-page',
                ...where,
                audience: 'internal',
            });
        for (const [sourceKey, table] of Object.entries(page?.tables ?? {}))
            if (table.internal?.active)
                issues.push({
                    ruleId: 'access.members-on-open-page',
                    ...where,
                    sourceKey,
                    audience: 'internal',
                });
    };
    checkMembers(undefined, undefined);
    for (const routePath of Object.keys(section.refresh.pages))
        if (!context.routes.some(candidate => (0, app_base_contract_1.normalizeAppRoutePath)(candidate.path) ===
            (0, app_base_contract_1.normalizeAppRoutePath)(routePath)))
            issues.push({ ruleId: 'access.unknown-page', routePath });
    for (const [routePath, page] of Object.entries(section.pages)) {
        const route = context.routes.find(candidate => (0, app_base_contract_1.normalizeAppRoutePath)(candidate.path) ===
            (0, app_base_contract_1.normalizeAppRoutePath)(routePath));
        if (!route) {
            issues.push({ ruleId: 'access.unknown-page', routePath });
            continue;
        }
        checkVisitor(page.audiences.public, { routePath });
        checkMembers(routePath, page);
        for (const [sourceKey, table] of Object.entries(page.tables)) {
            if (!route.dataSourceKeys.includes(sourceKey)) {
                issues.push({ ruleId: 'access.unknown-table', routePath, sourceKey });
                continue;
            }
            checkVisitor(table.public, { routePath, sourceKey });
            const known = context.columnIds?.[sourceKey];
            if (!known)
                continue;
            for (const audience of app_access_vocabulary_1.AppAccessAudienceSchema.options) {
                const access = table[audience];
                if (!access?.active)
                    continue;
                for (const columnId of access.readOnlyColumns)
                    if (!known.includes(columnId))
                        issues.push({
                            ruleId: 'access.unknown-column',
                            routePath,
                            sourceKey,
                            audience,
                            columnId,
                        });
            }
        }
        for (const grant of page.groups) {
            if (grant.sourceKey !== undefined &&
                !route.dataSourceKeys.includes(grant.sourceKey))
                issues.push({
                    ruleId: 'access.unknown-table',
                    routePath,
                    sourceKey: grant.sourceKey,
                });
            if (!isActive(pageAudience(section, page, grant.audience)))
                issues.push({
                    ruleId: 'access.group-grant-inactive-audience',
                    routePath,
                    audience: grant.audience,
                    groupId: grant.groupId,
                });
        }
    }
    return issues;
}
const AppAccessEditValueSchema = zod_1.z.union([
    app_access_vocabulary_1.AppInactiveAudienceSchema,
    zod_1.z
        .object({ active: zod_1.z.literal(true), template: app_access_vocabulary_1.AppAccessTemplateSchema })
        .strict(),
    app_access_vocabulary_1.AppAccessRightsSchema.extend({ active: zod_1.z.literal(true) }).strict(),
]);
/**
 * One change of the access section: the only way the Studio and the AI tools
 * change rights. `defaults` changes the container defaults, `set` a page or
 * one table of it, `inherit` drops an own setting again.
 */
exports.AppAccessEditSchema = zod_1.z
    .discriminatedUnion('kind', [
    zod_1.z
        .object({
        kind: zod_1.z.literal('defaults'),
        audience: app_access_vocabulary_1.AppAccessAudienceSchema,
        access: AppAccessEditValueSchema,
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('set'),
        routePath: zod_1.z.string().min(1),
        sourceKey: zod_1.z.string().min(1).optional(),
        audience: app_access_vocabulary_1.AppAccessAudienceSchema,
        access: AppAccessEditValueSchema,
        readOnlyColumns: zod_1.z.array(zod_1.z.string().min(1)).optional(),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('inherit'),
        routePath: zod_1.z.string().min(1),
        sourceKey: zod_1.z.string().min(1).optional(),
        audience: app_access_vocabulary_1.AppAccessAudienceSchema,
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('refresh'),
        /** Without a page the App setting; null drops an own setting. */
        routePath: zod_1.z.string().min(1).optional(),
        audience: exports.AppRefreshAudienceSchema,
        refresh: exports.AppPageRefreshSchema.nullable(),
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('groups'),
        routePath: zod_1.z.string().min(1),
        grants: zod_1.z.array(app_access_vocabulary_1.AppAccessGroupGrantSchema),
    })
        .strict(),
])
    .superRefine((edit, ctx) => {
    if (edit.kind !== 'set')
        return;
    if (edit.readOnlyColumns !== undefined &&
        (edit.sourceKey === undefined || !edit.access.active))
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['readOnlyColumns'],
            message: 'Read-only columns belong to an active table',
        });
});
function editedAudienceAccess(edit) {
    if (!edit.access.active)
        return { active: false };
    const rights = 'template' in edit.access
        ? exports.APP_ACCESS_TEMPLATES[edit.access.template]
        : edit.access;
    return {
        active: true,
        read: rights.read,
        create: rights.create,
        update: rights.update,
        delete: rights.delete,
    };
}
function editedTableAccess(edit) {
    const access = editedAudienceAccess(edit);
    return access.active
        ? { ...access, readOnlyColumns: edit.readOnlyColumns ?? [] }
        : access;
}
function withoutAudience(record, audience) {
    const { [audience]: _dropped, ...rest } = record;
    return rest;
}
/**
 * The edits that take over the page rights the Apps bring for their pages:
 * one per audience of a page and per audience of each of its tables. The
 * Studio applies them through the one access mutation; audiences a page
 * leaves out keep what the container says.
 */
function appAccessRecommendationEdits(routes) {
    return routes.flatMap(route => {
        const access = route.access;
        if (!access)
            return [];
        const routePath = route.path;
        const pageEdits = app_access_vocabulary_1.AppAccessAudienceSchema.options.flatMap((audience) => {
            const rights = access.audiences[audience];
            return rights
                ? [{ kind: 'set', routePath, audience, access: rights }]
                : [];
        });
        const tableEdits = Object.entries(access.tables).flatMap(([sourceKey, table]) => app_access_vocabulary_1.AppAccessAudienceSchema.options.flatMap((audience) => {
            const rights = table[audience];
            if (!rights)
                return [];
            if (!rights.active)
                return [
                    { kind: 'set', routePath, sourceKey, audience, access: rights },
                ];
            const { readOnlyColumns, ...tableRights } = rights;
            return [
                {
                    kind: 'set',
                    routePath,
                    sourceKey,
                    audience,
                    access: tableRights,
                    // As the editor writes it: columns only when there are some.
                    ...(readOnlyColumns.length > 0 && { readOnlyColumns }),
                },
            ];
        }));
        return [...pageEdits, ...tableEdits];
    });
}
function withRefreshEdit(current, edit) {
    const settings = (record) => {
        const { [edit.audience]: _old, ...rest } = record;
        return edit.refresh === null
            ? rest
            : { ...rest, [edit.audience]: edit.refresh };
    };
    if (edit.routePath === undefined)
        return exports.AppPageAccessSectionSchema.parse({
            ...current,
            refresh: { ...current.refresh, app: settings(current.refresh.app) },
        });
    const routePath = (0, app_base_contract_1.normalizeAppRoutePath)(edit.routePath);
    const pageKey = Object.keys(current.refresh.pages).find(key => (0, app_base_contract_1.normalizeAppRoutePath)(key) === routePath) ?? routePath;
    const { [pageKey]: page, ...otherPages } = current.refresh.pages;
    const next = settings(page ?? {});
    return exports.AppPageAccessSectionSchema.parse({
        ...current,
        refresh: {
            ...current.refresh,
            pages: Object.keys(next).length > 0
                ? { ...otherPages, [pageKey]: next }
                : otherPages,
        },
    });
}
/** The access section after one edit; the section itself stays unchanged. */
function applyAppAccessEdit(section, edit) {
    const current = exports.AppPageAccessSectionSchema.parse(section ?? {});
    if (edit.kind === 'refresh')
        return withRefreshEdit(current, edit);
    if (edit.kind === 'defaults') {
        return exports.AppPageAccessSectionSchema.parse({
            ...current,
            defaults: {
                ...current.defaults,
                [edit.audience]: editedAudienceAccess(edit),
            },
        });
    }
    const routePath = (0, app_base_contract_1.normalizeAppRoutePath)(edit.routePath);
    const pageKey = Object.keys(current.pages).find(key => (0, app_base_contract_1.normalizeAppRoutePath)(key) === routePath) ?? routePath;
    const page = current.pages[pageKey] ?? app_access_vocabulary_1.AppPageAccessSchema.parse({});
    const nextPage = (() => {
        if (edit.kind === 'groups')
            return { ...page, groups: edit.grants };
        if (edit.sourceKey === undefined) {
            if (edit.kind === 'inherit')
                return {
                    ...page,
                    audiences: withoutAudience(page.audiences, edit.audience),
                };
            return {
                ...page,
                audiences: {
                    ...page.audiences,
                    [edit.audience]: editedAudienceAccess(edit),
                },
            };
        }
        const table = page.tables[edit.sourceKey] ?? {};
        const nextTable = edit.kind === 'inherit'
            ? withoutAudience(table, edit.audience)
            : { ...table, [edit.audience]: editedTableAccess(edit) };
        const { [edit.sourceKey]: _old, ...otherTables } = page.tables;
        return {
            ...page,
            tables: Object.keys(nextTable).length > 0
                ? { ...otherTables, [edit.sourceKey]: nextTable }
                : otherTables,
        };
    })();
    return exports.AppPageAccessSectionSchema.parse({
        ...current,
        pages: { ...current.pages, [pageKey]: nextPage },
    });
}
/**
 * The page rights after the pages of a container changed: a page that moved
 * takes its rights to its new path; a new page starts with exactly the rights
 * its App brings and nothing else; every other entry stays as it is.
 */
/**
 * The pages of a container whose rights an installation keeps: the pages of
 * an installed App and every page with its own rights. The placeholder home
 * page of a new container is neither, so the App placed there brings its
 * rights.
 */
function appPagesKeepingRights(input) {
    const appPages = new Set(input.routeSeo
        .filter(seo => seo.owner.kind === 'app')
        .map(seo => (0, app_base_contract_1.normalizeAppRoutePath)(seo.routePath)));
    return input.routes
        .map(route => route.path)
        .filter(path => appPages.has((0, app_base_contract_1.normalizeAppRoutePath)(path)) ||
        findPage(input.section, path) !== undefined);
}
function appPageAccessForRoutes(input) {
    let section = exports.AppPageAccessSectionSchema.parse(input.section ?? {});
    const previousPaths = new Set(input.previousRoutePaths.map(app_base_contract_1.normalizeAppRoutePath));
    const previousPathByPath = new Map([...(input.previousPathByPath ?? [])].map(([path, previous]) => [
        (0, app_base_contract_1.normalizeAppRoutePath)(path),
        (0, app_base_contract_1.normalizeAppRoutePath)(previous),
    ]));
    const routes = input.routes.map(route => {
        const path = (0, app_base_contract_1.normalizeAppRoutePath)(route.path);
        return { route, path, previous: previousPathByPath.get(path) ?? path };
    });
    // Read all moved rights before removing keys, including when Apps swap places.
    const moved = routes
        .filter(({ path, previous }) => previous !== path)
        .map(({ path, previous }) => ({
        path,
        previous,
        access: findPage(section, previous),
        refresh: findRefreshPage(section, previous),
    }));
    // A page takes its rights and its refresh along.
    const dropPage = (path) => {
        for (const pages of [section.pages, section.refresh.pages]) {
            for (const key of Object.keys(pages)) {
                if ((0, app_base_contract_1.normalizeAppRoutePath)(key) === path)
                    delete pages[key];
            }
        }
    };
    for (const { previous } of moved)
        dropPage(previous);
    for (const { path, access, refresh } of moved) {
        dropPage(path);
        if (access)
            section.pages[path] = access;
        if (refresh)
            section.refresh.pages[path] = refresh;
    }
    for (const { route, path, previous } of routes) {
        if (previousPaths.has(previous))
            continue;
        dropPage(path);
        for (const edit of appAccessRecommendationEdits([route])) {
            section = applyAppAccessEdit(section, edit);
        }
    }
    return section;
}
/** The rules an edit breaks: issues the section did not have before it. */
function appAccessEditIssues(before, after, context) {
    const key = (issue) => JSON.stringify(issue);
    const known = new Set(before ? validateAppPageAccess(before, context).map(key) : []);
    return validateAppPageAccess(after, context).filter(issue => !known.has(key(issue)));
}
/**
 * The tables a command of an App works on, in the App's own source keys: the
 * same tables the page admission checks for it (appActionTableOperations).
 */
function appCommandTables(definition, command) {
    switch (command.type) {
        case 'rowInsert':
        case 'attachmentUpdate':
        case 'ownRowChange':
            return [command.sourceKey];
        case 'rowGroupInsert':
            return (definition.agentActions
                .find(action => action.id === command.agentActionId)
                ?.bindings.map(binding => binding.sourceKey) ?? []);
        case 'automationRun':
            return [];
    }
}
/**
 * The tables a page of an App may give rights on: the tables it shows, the
 * tables of the commands it leads (action:<id> among its controls) and the
 * tables of its Agent Actions.
 */
function appPageTables(definition, page) {
    const commandIds = new Set(page.interactionControlIds.flatMap(controlId => {
        const commandId = (0, app_base_contract_1.actionIdFromInteractionControlId)(controlId);
        return commandId === null ? [] : [commandId];
    }));
    const agentActionIds = new Set(page.route.agentActionIds);
    return [
        ...new Set([
            ...page.route.dataSourceKeys,
            ...definition.commands
                .filter(command => commandIds.has(command.id))
                .flatMap(command => appCommandTables(definition, command)),
            ...definition.agentActions
                .filter(action => agentActionIds.has(action.id))
                .flatMap(action => action.bindings.map(binding => binding.sourceKey)),
        ]),
    ];
}
/**
 * The rules the page rights of an App break, with the rule ids of the access
 * section of a container. A page gives rights only on its own tables
 * (appPageTables); it may close any other table of its App, since a table
 * without an entry takes the rights of the page.
 */
function appDefinitionAccessIssues(definition) {
    const routes = definition.routes.map(page => ({
        path: page.route.path,
        access: page.route.access,
        dataSourceKeys: appPageTables(definition, page),
    }));
    const section = exports.AppPageAccessSectionSchema.parse({
        pages: Object.fromEntries(routes.flatMap(route => route.access ? [[route.path, route.access]] : [])),
    });
    for (const route of routes) {
        const page = section.pages[route.path];
        if (!page)
            continue;
        page.tables = Object.fromEntries(Object.entries(page.tables).filter(([sourceKey, table]) => route.dataSourceKeys.includes(sourceKey) ||
            app_access_vocabulary_1.AppAccessAudienceSchema.options.some(audience => table[audience]?.active)));
    }
    return validateAppPageAccess(section, { routes });
}
/** One access issue as the checks name it: the rule and where it holds. */
function formatAppPageAccessIssue(issue) {
    const where = [
        issue.routePath && `page ${issue.routePath}`,
        issue.sourceKey && `table ${issue.sourceKey}`,
        issue.audience && `audience ${issue.audience}`,
        issue.columnId && `column ${issue.columnId}`,
        issue.groupId && `group ${issue.groupId}`,
    ].filter(Boolean);
    return where.length > 0
        ? `${issue.ruleId} (${where.join(', ')})`
        : issue.ruleId;
}
/**
 * Whether an App Container serves a portal (sign-in, session, account): its
 * page rights let portal people open a page.
 */
function appBaseServesPortal(appBaseConfig) {
    if (appBaseConfig.productMode !== 'app-base')
        return false;
    return appBaseReachedAudiences(appBaseConfig).includes('portal');
}
